import PropTypes from 'prop-types';
import React from 'react';

export default class LetterButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isSelected: false
        };

        this.setIsSelected = this.setIsSelected.bind(this);
        this.setIsUnselected = this.setIsUnselected.bind(this);
    }

    getStyles() {
        const styles = ['letter-button'];

        if (!this.props.isEnabled) {
            styles.push('disabled-button');
        }

        if (this.props.isSelected) {
            styles.push('selected');
        }

        return styles.join(' ');
    }

    setIsSelected () {
        this.setState({isSelected: true});
    }

    setIsUnselected() {
        this.setState({isSelected: false});
    }

    render() {
        return (
            // eslint-disable-next-line jsx-a11y/role-supports-aria-props
            <button
                aria-label={this.props.text}
                aria-selected={this.state.isSelected}
                onFocus={this.setIsSelected}
                onBlur={this.setIsUnselected}
                aria-disabled={!this.props.isEnabled}
                tabIndex={!this.props.isEnabled || this.props.isDisabled ? '-1' : 0}
                className={this.getStyles()}
                onClick={(e) => {
                    this.props.onButtonClick();
                    e.currentTarget.blur();
                }}
            >
                { this.props.text }
            </button>
        );
    }
}

LetterButton.propTypes = {
    text: PropTypes.string.isRequired,
    onButtonClick: PropTypes.func.isRequired,
    isEnabled: PropTypes.bool,
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,
};

LetterButton.defaultProps = {
    isEnabled: true,
    isSelected: false,
    isDisabled: false,
};
